export const arqDig1050KeyFactory = {
  allFromRede: (cnpjMatriz) => [{ scope: 'arqDig1050', cnpjMatriz }],
  filteredFromRede: (cnpjMatriz, filters = {}) => [
    { ...arqDig1050KeyFactory.allFromRede(cnpjMatriz)[0], ...filters },
  ],
};
